import {
    apiRequest,
    riwayatsumpahList,
    riwayatsumpahActive,
    riwayatsumpahInactive
} from "../../../../../services/adapters/kepegawaian/riwayatsumpahService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", riwayatsumpahList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", riwayatsumpahInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", riwayatsumpahActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository